let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("g06nS")).then(() => parcelRequire('12FUM'));